// Display status for a team member.
//
// The membership row is created ACTIVE the moment someone is invited (auth-service
// provisionMember), so `status` alone can't tell an invited person from one who
// actually uses the portal. auth-service also returns `lastLoginAt` (FusionAuth
// lastLoginInstant): null means they have never signed in.
//
// - INVITED: explicit INVITED status, or ACTIVE with lastLoginAt === null
// - otherwise the stored status. If lastLoginAt is missing entirely (older
//   auth-service, or the profile lookup failed) we don't guess.
export const memberDisplayStatus = (member) => {
  if (!member) return undefined;
  if (member.status === 'INVITED') return 'INVITED';
  if (member.status === 'ACTIVE' && member.lastLoginAt === null) return 'INVITED';
  return member.status;
};
